import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';

import TextField from 'material-ui/TextField';

import { updateCargoOrder } from 'actions/cargoes/orders';
import { SelectField, MenuItem } from 'material-ui';
import helpers from 'helpers';

const styles = {
    selectField: {
        padding: '0 5px',
        width: '256px',
        fontSize: '13px',
    },
    menuItem: {
        width: 'auto',
        fontSize: '13px',
    },
};

class CommisionAndContracts extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: this.props.value,
        };

        this.selectContracts = this.selectContracts.bind(this);
        this.onChangeCommision = this.onChangeCommision.bind(this);
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        if (newProps.value !== this.props.value) {
            this.setState({
                value: newProps.value,
            });
        }
    }

    onChangeCommision(e) {
        const newCargoOrder = Object.assign({}, this.props.cargoOrder);
        
        const value = helpers.clearLetters(e.target.value);

        newCargoOrder.comm = value || undefined;

        if (parseFloat(newCargoOrder.comm) !== 0 && !newCargoOrder.comm) {
            newCargoOrder.validateErrors.push({
                field: 'comm',
                messages: ['Commission is required'],
            });
        } else {
            newCargoOrder.validateErrors = newCargoOrder.validateErrors
                .filter(obj => obj.field !== 'comm');
        }

        this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
    }

    selectContracts(value) {
        const newCargoOrder = _.cloneDeep(this.props.cargoOrder);
        const contract = this.props.contracts.find(item => item.name === value);

        newCargoOrder.contract = contract._id;

        this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);

        this.setState({ value: contract.name });
    }

    render() {
        let errorCommision;

        if (this.props.errorCommision) {
            if (this.props.errorCommision.message) {
                errorCommision = this.props.errorCommision.message || '';
            } else if (this.props.errorCommision.messages) {
                errorCommision = this.props.errorCommision.messages[0] || '';
            }
        }
        
        return (
            <div className='row half'>
                <div 
                    className='column-left'
                    style={{
                        display: 'flex',
                        height: '92px',
                    }}    
                >
                    <span
                        style={{
                            display: 'block',
                            margin: '42px 0',
                        }}
                    >
                        Commission:
                    </span>
                    <TextField
                        floatingLabelText="Commission"
                        errorText={errorCommision}
                        style={{ fontSize: '13px', marginLeft: '10px' }}
                        value={this.props.cargoOrder.comm || ''}
                        hintText='Commission'
                        onChange={this.onChangeCommision}
                        name='comm'
                    />
                </div>
                <div className='column-right half'>
                    <span style={{ fontSize: '13px', margin: '40px 10px 0px 0px' }}>Contract:</span>
                    <SelectField
                        floatingLabelText="Contract"
                        style={styles.selectField}
                        value={this.state.value} 
                        onChange={(_event, _index, value) => { this.selectContracts(value); }}
                        maxHeight={200}
                        autoWidth
                    >
                        {this.props.contracts.map((contract, key) => (<MenuItem
                            key={key}
                            style={styles.menuItem}
                            value={contract.name}
                            primaryText={contract.name}
                        />))}
                    </SelectField>
                </div>
            </div>
        );
    }
}

export default connect(
    (state, ownProps) => {
        const cargoOrder = state.cargoOrders.items[ownProps.numberOrderTable];

        if (!cargoOrder.contract) {
            cargoOrder.contract = state.contracts && state.contracts.items.find(c => c.name === 'TBA')._id;
        }

        const errorCommision = cargoOrder.validateErrors.find(validateError => validateError.field === 'comm');

        const value = state.contracts.items.find(contract => contract._id === cargoOrder.contract);

        return {
            numberOrderTable: ownProps.numberOrderTable,
            cargoOrder,
            errorCommision,
            contracts: state.contracts.items,
            value: value ? value.name : '',
        };
    },
    dispatch => bindActionCreators({
        updateCargoOrder,
    }, dispatch),
)(CommisionAndContracts);



// WEBPACK FOOTER //
// ./app/components/Letters/SingleNew/Cargo/Sidebar/Order/CommisionAncContracts.jsx